import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-219a53b0"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = { class: "blogs-wrapper" }
const _hoisted_3 = ["href"]
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "text-body-light" }

import axios from 'axios'
import { onMounted, ref } from 'vue'
import { useGettext } from 'vue3-gettext'
import LoaderErrorBlock from '@/components/CommonUI/LoaderErrorBlock.vue'
import { getErrorMessage } from '@/helpers/errors'


export default /*#__PURE__*/_defineComponent({
  __name: 'BlogsBlock',
  setup(__props) {

const { $gettext, current } = useGettext()

const articles = ref([] as BlogArticle[])
const isLoaded = ref(false)
const errorMessage = ref('')
const title = ref($gettext('<span class="light-text">Learn more about</span> Music Publishing'))

onMounted(async () => {
  try {
    const { data } = await axios.get(
      `${process.env.VUE_APP_BLOG_PUBLISHING_SOURCE}/${current}/${process.env.VUE_APP_BLOG_PUBLISHING_ARTICLES}` as string,
    )

    isLoaded.value = true
    articles.value = data as BlogArticle[]
  } catch (error) {
    errorMessage.value = getErrorMessage(error)
  }
})

function getBlogLink(slug: string): string {
  return `${process.env.VUE_APP_BLOG_PUBLISHING_SOURCE}/${current}/blog/${slug}`
}

return (_ctx: any,_cache: any) => {
  return (!isLoaded.value)
    ? (_openBlock(), _createBlock(LoaderErrorBlock, {
        key: 0,
        "error-message": errorMessage.value,
        class: "row no-space justify-center",
        "data-testid": "blogs-block-error"
      }, null, 8, ["error-message"]))
    : (articles.value.length)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("h2", {
            "data-testid": "blogs-block",
            innerHTML: title.value
          }, null, 8, _hoisted_1),
          _createElementVNode("div", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(articles.value, (article) => {
              return (_openBlock(), _createElementBlock("div", {
                key: article.id,
                class: "blog-item",
                "data-testid": "blog-item"
              }, [
                _createElementVNode("a", {
                  href: getBlogLink(article.slug)
                }, [
                  _createElementVNode("img", {
                    src: article.articleImage.url,
                    alt: "blog-image"
                  }, null, 8, _hoisted_4),
                  _createElementVNode("h4", null, _toDisplayString(article.title), 1),
                  _createElementVNode("p", _hoisted_5, _toDisplayString(article.content.text), 1)
                ], 8, _hoisted_3)
              ]))
            }), 128))
          ])
        ], 64))
      : _createCommentVNode("", true)
}
}

})